import { grey } from "@mui/material/colors";

export const headerCellStyle = { backgroundColor: grey[100], fontSize: 18 }

export const cellStyle = {
  fontSize: 18,
  verticalAlign: "top",
};

export const cellWidePaddingStyle = {
  ...cellStyle,
  py: 3
}

export const tableInRowStyle = {
  "& td" : {
    px: 0,
  },
  "&:last-child": {
    "& td" : {
      borderBottom: 0,
      pb: 0
    }
  },
  "&:first-child": {
    "& td" : {
      pt: 0
    }
  }
}

export const orderCellStyles = {
  unitQuantity: {
    width: "50%",
    minWidth: 80
  },
  orderAmount : {
    width: "45%",
    minWidth: 50
  },
}

export const stockCellStyles = {
  unitQuantity: {
    width: "32%",
    minWidth: 50
  },
  boxAmount : {
    width: "32%",
    minWidth: 50
  },
  singleAmount : {
    width: "32%",
    minWidth: 50
  },
}

export const supplyCellStyles = {
  leftBorder : {
    borderLeft: "1px gray solid"
  },
  validUnitQuantityCheck: {
    width: 50,
  },
}

// Shrink-to-content columns: width "1%" + whiteSpace "nowrap" prevents table from expanding these
const shrinkCell = {
  width: "1%",
  whiteSpace: "nowrap",
  textAlign: "center",
  verticalAlign: "middle",
  padding: "2px 4px",
}

export const supplyProductStyles = {
  dragHandle: {
    ...shrinkCell,
  },
  hideButton: {
    ...shrinkCell,
  },
  productName: {
    ...cellWidePaddingStyle,
    width: "10%",
    minWidth: 150,
    fontWeight: "bold",
    fontSize: 20
  },
  origin: {
    ...cellWidePaddingStyle,
    width: "10%",
    minWidth: 150
  },
  size: {
    ...cellWidePaddingStyle,
    width: "8%",
    minWidth: 130
  },
  supplyUnit: {
    ...cellWidePaddingStyle,
    width: "8%",
    minWidth: 130
  },
  order: {
    ...cellWidePaddingStyle,
    width: "11%",
    minWidth: 170
  },
  stock: {
    ...cellWidePaddingStyle,
    width: "15%",
    minWidth: 185
  },
  totalSupplyAmount : {
    ...cellWidePaddingStyle,
    width: "8%",
    textAlign: "right",
    minWidth: 100
  },
  supply: {
    ...cellStyle,
    width: "20%",
    minWidth: 330
  },
  supplyWithRemarks: {
    ...cellStyle,
    width: "20%",
    minWidth: 430
  },
  deleteSupply: {
    ...cellStyle,
    width: "8%",
    minWidth: 130
  }
}